<h2 mat-dialog-title autoTranslate>Fechar turno</h2>

<mat-dialog-content class="ca-dialog">
    <p class="ca-dialog__meta">{{ data.label }}</p>

    <section class="ca-dialog__section" *ngIf="hasCrewChoice">
        <span class="ca-dialog__label" autoTranslate>Quem deve sair do turno?</span>
        <div class="ca-dialog__options">
            <button
                type="button"
                class="ca-dialog__option"
                [class.ca-dialog__option--active]="scope === 'person'"
                [disabled]="data.isOnlyDriver"
                (click)="selectScope('person')"
            >
                <span class="ca-dialog__option-title" autoTranslate>Só esta pessoa</span>
                <span class="ca-dialog__option-desc" autoTranslate>
                    Remove apenas este profissional; os demais continuam no turno.
                </span>
            </button>
            <button
                type="button"
                class="ca-dialog__option"
                [class.ca-dialog__option--active]="scope === 'all'"
                (click)="selectScope('all')"
            >
                <span class="ca-dialog__option-title" autoTranslate>Todos desta alocação</span>
                <span class="ca-dialog__option-desc" autoTranslate>Encerra o turno de toda a equipe.</span>
            </button>
        </div>
        <p class="ca-dialog__hint" *ngIf="data.isOnlyDriver" autoTranslate>
            Este motorista é o único da alocação. Fechar só esta pessoa encerraria o turno da viatura.
        </p>
    </section>

    <section class="ca-dialog__section" *ngIf="scope === 'all'">
        <span class="ca-dialog__label" autoTranslate>Horário de fechamento</span>
        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <input matInput type="datetime-local" [(ngModel)]="endedAtLocal" />
        </mat-form-field>
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" autoTranslate>Cancelar</button>
    <button
        mat-flat-button
        color="warn"
        type="button"
        [disabled]="scope === 'all' && !endedAtLocal"
        (click)="confirm()"
        autoTranslate
    >
        Fechar turno
    </button>
</mat-dialog-actions>
